<template>
  <div>
    <Select
      v-model="province"
      style="width: 150px; margin-right: 10px"
      @on-change="selectProvince"
    >
      <Option value="省" key="省">省</Option>
      <Option
        v-for="item in provinceList"
        :value="item.name"
        :key="item.name"
        >{{ item.name }}</Option
      >
    </Select>
    <Select
      v-model="city"
      style="width: 150px; margin-right: 10px"
      @on-change="selectCity"
      v-if="subdistrict >= 2"
    >
      <Option value="市" key="市">市</Option>
      <Option v-for="item in cityList" :value="item.name" :key="item.name">{{
        item.name
      }}</Option>
    </Select>
    <Select
      v-model="district"
      style="width: 150px; margin-right: 10px"
      @on-change="selectdistrict"
      v-if="subdistrict >= 3"
    >
      <Option value="区" key="区">区</Option>
      <Option
        v-for="item in districtList"
        :value="item.name"
        :key="item.name"
        >{{ item.name }}</Option
      >
    </Select>
    <Select
      v-model="street"
      style="width: 150px"
      v-if="subdistrict >= 4"
      @on-change="selectStreet"
    >
      <Option value="镇" key="镇">镇</Option>
      <Option v-for="item in streetList" :value="item.name" :key="item.name">{{
        item.name
      }}</Option>
    </Select>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "YnAddress",
  props: {
    subdistrict: {
      type: Number,
      default() {
        return 3;
      },
    },
    value: Object,
  },
  created() {
    if (this.value) {
      //省
      this.province = this.value.province;
      if (this.subdistrict > 1) {
        var list = this.provinceList.filter((a) => {
          return a.name == this.province;
        });
        if (list != null && list.length > 0) {
          var model = list[0];
          axios
            .get(
              `https://restapi.amap.com/v3/config/district?subdistrict=1&key=53f9179766addce3a23af594105385e6&keywords=${model.adcode}`
            )
            .then((res) => {
              if (res.data.status == "1") {
                var districts = res.data.districts;
                if (districts.length > 0) {
                  var model = districts[0];
                  var list = model.districts;
                  this.cityList = list;
                  this.city = this.value.city;

                  this.iniDistrit();
                }
              }
            });
        }
      }
    }
  },
  methods: {
    iniDistrit() {
      if (this.subdistrict > 2) {
        var list = this.cityList.filter((a) => {
          return a.name == this.city;
        });
        if (list != null && list.length > 0) {
          var model = list[0];
          axios
            .get(
              `https://restapi.amap.com/v3/config/district?subdistrict=1&key=53f9179766addce3a23af594105385e6&keywords=${model.adcode}`
            )
            .then((res) => {
              if (res.data.status == "1") {
                var districts = res.data.districts;
                if (districts.length > 0) {
                  var model = districts[0];
                  var list = model.districts;
                  this.districtList = list;
                  this.district = this.value.district;

                  this.initStreet();
                }
              }
            });
        }
      }
    },
    initStreet() {
      if (this.subdistrict > 3) {
        var list = this.districtList.filter((a) => {
          return a.name == this.district;
        });
        if (list != null && list.length > 0) {
          var model = list[0];
          axios
            .get(
              `https://restapi.amap.com/v3/config/district?subdistrict=1&key=53f9179766addce3a23af594105385e6&keywords=${model.adcode}`
            )
            .then((res) => {
              if (res.data.status == "1") {
                var districts = res.data.districts;
                if (districts.length > 0) {
                  var model = districts[0];
                  var list = model.districts;
                  this.streetList = list;
                  this.street = this.value.street;
                }
              }
            });
        }
      }
    },
    selectProvince(value) {
      this.city = "市";
      this.district = "区";
      this.street = "镇";
      var list = this.provinceList.filter((a) => {
        return a.name == value;
      });
      if (list != null && list.length > 0) {
        this.value.province = list[0].name;
        this.getInfo(list[0].adcode, 2);
      }

      if (this.subdistrict == 1) {
        this.$emit("selectAddress", this.value);
      }
    },
    selectCity(value) {
      this.district = "区";
      this.street = "镇";
      var list = this.cityList.filter((a) => {
        return a.name == value;
      });
      if (list != null && list.length > 0) {
        this.value.city = list[0].name;
        this.getInfo(list[0].adcode, 3);
      }
      if (this.subdistrict == 2) {
        this.$emit("selectAddress", this.value);
      }
    },
    selectdistrict(value) {
      this.street = "镇";
      var list = this.districtList.filter((a) => {
        return a.name == value;
      });
      if (list != null && list.length > 0) {
        this.value.district = list[0].name;
        this.getInfo(list[0].adcode, 4);
      }
      if (this.subdistrict == 3) {
        this.$emit("selectAddress", this.value);
      }
    },
    selectStreet(value) {
      var list = this.streetList.filter((a) => {
        return a.name == value;
      });
      if (list != null && list.length > 0) {
        this.value.street = list[0].name;
      }
      if (this.subdistrict == 4) {
        this.$emit("selectAddress", this.value);
      }
    },
    getInfo(adcode, type) {
      axios
        .get(
          `https://restapi.amap.com/v3/config/district?subdistrict=1&key=53f9179766addce3a23af594105385e6&keywords=${adcode}`
        )
        .then((res) => {
          if (res.data.status == "1") {
            var districts = res.data.districts;
            if (districts.length > 0) {
              var model = districts[0];
              var list = model.districts;
              switch (type) {
                case 2:
                  this.cityList = list;
                  break;
                case 3:
                  this.districtList = list;
                  break;
                case 4:
                  this.streetList = list;
                  break;
              }
            }
          }
        });
    },
  },
  watch: {
    value: function () {
      const self = this;
      if (this.value) {
        //省
        this.province = this.value.province;
        if (this.subdistrict > 1) {
          var list = this.provinceList.filter((a) => {
            return a.name == this.province;
          });
          if (list != null && list.length > 0) {
            var model = list[0];
            axios
              .get(
                `https://restapi.amap.com/v3/config/district?subdistrict=1&key=53f9179766addce3a23af594105385e6&keywords=${model.adcode}`
              )
              .then((res) => {
                if (res.data.status == "1") {
                  var districts = res.data.districts;
                  if (districts.length > 0) {
                    var model = districts[0];
                    var list = model.districts;
                    this.cityList = list;
                    this.city = this.value.city;

                    this.iniDistrit();
                  }
                }
              });
          }
        }
      }
    },
  },
  data() {
    return {
      //省
      province: "省",
      //市
      city: "市",
      //区
      district: "区",
      //镇
      street: "镇",
      cityList: [],
      districtList: [],
      streetList: [],
      provinceList: [
        {
          citycode: [],
          adcode: "410000",
          name: "河南省",
          center: "113.665412,34.757975",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "440000",
          name: "广东省",
          center: "113.280637,23.125178",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "150000",
          name: "内蒙古自治区",
          center: "111.670801,40.818311",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "230000",
          name: "黑龙江省",
          center: "126.642464,45.756967",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "650000",
          name: "新疆维吾尔自治区",
          center: "87.617733,43.792818",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "420000",
          name: "湖北省",
          center: "114.298572,30.584355",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "210000",
          name: "辽宁省",
          center: "123.429096,41.796767",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "370000",
          name: "山东省",
          center: "117.000923,36.675807",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "610000",
          name: "陕西省",
          center: "108.948024,34.263161",
          level: "province",
          districts: [],
        },
        {
          citycode: "021",
          adcode: "310000",
          name: "上海市",
          center: "121.472644,31.231706",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "520000",
          name: "贵州省",
          center: "106.713478,26.578343",
          level: "province",
          districts: [],
        },
        {
          citycode: "023",
          adcode: "500000",
          name: "重庆市",
          center: "106.504962,29.533155",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "540000",
          name: "西藏自治区",
          center: "91.132212,29.660361",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "340000",
          name: "安徽省",
          center: "117.283042,31.86119",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "350000",
          name: "福建省",
          center: "119.306239,26.075302",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "430000",
          name: "湖南省",
          center: "112.982279,28.19409",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "460000",
          name: "海南省",
          center: "110.33119,20.031971",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "320000",
          name: "江苏省",
          center: "118.767413,32.041544",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "630000",
          name: "青海省",
          center: "101.778916,36.623178",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "450000",
          name: "广西壮族自治区",
          center: "108.320004,22.82402",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "640000",
          name: "宁夏回族自治区",
          center: "106.278179,38.46637",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "360000",
          name: "江西省",
          center: "115.892151,28.676493",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "330000",
          name: "浙江省",
          center: "120.153576,30.287459",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "130000",
          name: "河北省",
          center: "114.502461,38.045474",
          level: "province",
          districts: [],
        },
        {
          citycode: "1852",
          adcode: "810000",
          name: "香港特别行政区",
          center: "114.173355,22.320048",
          level: "province",
          districts: [],
        },
        {
          citycode: "1886",
          adcode: "710000",
          name: "台湾省",
          center: "121.509062,25.044332",
          level: "province",
          districts: [],
        },
        {
          citycode: "1853",
          adcode: "820000",
          name: "澳门特别行政区",
          center: "113.54909,22.198951",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "620000",
          name: "甘肃省",
          center: "103.823557,36.058039",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "510000",
          name: "四川省",
          center: "104.065735,30.659462",
          level: "province",
          districts: [],
        },
        {
          citycode: "022",
          adcode: "120000",
          name: "天津市",
          center: "117.190182,39.125596",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "530000",
          name: "云南省",
          center: "102.712251,25.040609",
          level: "province",
          districts: [],
        },
        {
          citycode: "010",
          adcode: "110000",
          name: "北京市",
          center: "116.405285,39.904989",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "220000",
          name: "吉林省",
          center: "125.3245,43.886841",
          level: "province",
          districts: [],
        },
        {
          citycode: [],
          adcode: "140000",
          name: "山西省",
          center: "112.549248,37.857014",
          level: "province",
          districts: [],
        },
      ],
    };
  },
};
</script>